import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, Loader2 } from "lucide-react";
import { buyBundle } from "@/lib/buy";

export default function Hero() {
  const ref = useRef(null);
  const [buying, setBuying] = useState(false);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "10%"]);

  return (
    <section ref={ref} id="top" className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#0d0b09]" data-testid="hero-section">
      <motion.div style={{ y: bgY }} className="absolute inset-0">
        <img
          src="/assets/noxway-poster.jpg"
          alt="NOXWAY gel applied to vegetation"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-10 w-full">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <div className="font-tech text-[11px] tracking-[0.3em] text-[#ff8b52] uppercase mb-6" data-testid="hero-kicker">
            Wildfire protection gel — Formula 100
          </div>
          <h1 className="font-display font-bold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="hero-headline">
            Protect your property when wildfire threatens.
          </h1>
          <p className="mt-6 text-base sm:text-lg text-white/80 leading-relaxed" data-testid="hero-subheadline">
            NOXWAY™ creates a 24–48 hour protective gel barrier on vegetation and structures — a hydration shield
            against radiant heat and ember strikes. Non-toxic, biodegradable, garden-hose simple.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={() => {
                setBuying(true);
                buyBundle("noxway_formula_100");
                setTimeout(() => setBuying(false), 1500);
              }}
              disabled={buying}
              data-testid="hero-shop-button"
              className="inline-flex items-center gap-2.5 font-display font-bold tracking-wide text-sm px-8 py-4 rounded-md bg-[#f97316] text-white hover:bg-[#ea580c] transition-colors disabled:opacity-70"
            >
              {buying && <Loader2 size={16} className="animate-spin" />}
              {buying ? "REDIRECTING…" : "SHOP NOXWAY — CA$1,299"}
            </button>
            <a
              href="#how"
              data-testid="hero-how-button"
              className="inline-flex items-center gap-2.5 font-display font-bold tracking-wide text-sm px-8 py-4 rounded-md border border-white/40 text-white hover:bg-white hover:text-[#17150f] transition-colors"
            >
              SEE HOW IT WORKS
              <ArrowDown size={16} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
